import { SecuredAPMProxyClient } from "Core/Api/APMProxy/SecuredAPMProxyClient";
import moment from 'moment';
import TrackedBolResultModel from "./TrackedBolResultsModel";
import { SecuredKoppClient } from "Core/Api/Kopp/SecuredKoppClient";
import { AddTrackedBolCommandRequest, IAddTrackedBolCommandRequest, ISlimUser, AddTrackedBolCommandResponse, GetTrackedBolDetailsByIdCommandRequest, SlimTrackedBol, GetTrackedBolDetailsByBolReferenceCommandRequest, IGetTrackedBolDetailsByBolReferenceCommandRequest, AddTrackedBolRequestModel, IAddTrackedBolRequestModel } from "Core/Api/Kopp/Api";

export class TrackedBolSearchFormHandler {
    props: any;
    constructor(props) {
        this.props = props;
    }

    GetBillOfLading(trackedBolSearch: string) {
        let client = new SecuredAPMProxyClient();
        client.showLoading = true;
        var results: TrackedBolResultModel;
        const storagetoDate = moment().format('YYYYMMDD');
        return client.getBillOfLadingInfo(trackedBolSearch, storagetoDate).then(x => {
            if (x.errors !== undefined && x.errors.length) {
                throw Error(x.errors[0]);
            }
            if (x !== undefined && x.bolReferenceNos !== undefined) {
                results = {
                    bolNumber: trackedBolSearch,
                    refNumber: x.bolReferenceNos[0],
                    description: x.bolExtraData?.filter(x => x.bilReference)[0].description,
                    vesselName: x.shipName,
                    voyage: x.arrivalDate,
                    isClickNGo: x.bolExtraData?.filter(x => x.bilReference)[0].clickAndGo,
                    arrivalDate: moment(storagetoDate, "YYYYMMDD"),
                    charges: x.data,
                    total: x.data?.filter(x => x.chargeType).reduce((p, c) => p + c.chargeAmount!, 0),
                    status: "Valid", //will update with logic later
                    consigneeName:x.bolExtraData?.filter(x=>x.bilReference)[0].customerName,
                    shipperName:x.bolExtraData?.filter(x=>x.bilReference)[0].shipperName,
                    numberOfPieces:x.bolExtraData?.filter(x=>x.bilReference)[0].numberOfPieces
                };
            }

            console.log("results", results);
            return results;
        });
    }

    GetTrackedBolByBolReference(bolRef: string) {
        const client = new SecuredKoppClient();

        client.showLoading = true;
        client.handleSecurityError = false;
        client.handleGeneralError = false;
        let request: IGetTrackedBolDetailsByBolReferenceCommandRequest = {
            bolReference: bolRef
        };
        return client.getTrackedBolDetailsByBolReference(request as GetTrackedBolDetailsByBolReferenceCommandRequest)
    }

    AddTrackedBol(trackedBols: IAddTrackedBolRequestModel[]): Promise<AddTrackedBolCommandResponse> {

        let client = new SecuredKoppClient();
        client.showLoading = true;
        client.handleGeneralError = true;

        let request = new AddTrackedBolCommandRequest({ addTrackedBolRequests: trackedBols });

        return client.addTrackedBol(request);

    }

    //TODO: CREATE METHOD TO EDIT TRACKEDBOL
}

export default TrackedBolSearchFormHandler
